import { motion, useReducedMotion } from "framer-motion";

const SLIDE_X = 44;

/**
 * Slide-in on scroll (horizontal + light vertical) + magnify / lift on hover.
 * Respects prefers-reduced-motion.
 *
 * @param {'left' | 'right' | 'up' | 'alternate'} slideFrom - Entrance direction.
 *   `alternate` toggles left/right by index for grid rows.
 * @param {boolean} slide - If false, uses legacy vertical-only entrance (y only).
 */
export function AnimatedCard({
  children,
  className = "",
  index = 0,
  enableHover = true,
  hoverScale = 1.035,
  hoverLift = -8,
  slide = true,
  slideFrom = "left",
}) {
  const reduceMotion = useReducedMotion();

  const initialHidden = (() => {
    if (reduceMotion) return false;
    if (!slide) {
      return { opacity: 0, y: 28, x: 0 };
    }
    if (slideFrom === "up") {
      return { opacity: 0, y: 32, x: 0 };
    }
    if (slideFrom === "right") {
      return { opacity: 0, x: SLIDE_X, y: 10 };
    }
    if (slideFrom === "alternate") {
      const x = index % 2 === 0 ? -SLIDE_X : SLIDE_X;
      return { opacity: 0, x, y: 10 };
    }
    return { opacity: 0, x: -SLIDE_X, y: 10 };
  })();

  const animateIn = reduceMotion
    ? undefined
    : {
        opacity: 1,
        x: 0,
        y: 0,
      };

  return (
    <motion.div
      className={className}
      initial={initialHidden}
      whileInView={animateIn}
      viewport={{ once: true, amount: 0.15, margin: "0px 0px -40px 0px" }}
      transition={{
        duration: reduceMotion ? 0 : 0.55,
        delay: reduceMotion ? 0 : index * 0.06,
        ease: [0.22, 1, 0.36, 1],
      }}
      whileHover={
        reduceMotion || !enableHover
          ? undefined
          : {
              ...(hoverScale !== 1 ? { scale: hoverScale } : {}),
              y: hoverLift,
              transition: { type: "spring", stiffness: 420, damping: 26 },
            }
      }
    >
      {children}
    </motion.div>
  );
}
